import React from "react";

export default function FourOhFour() {
  return <div>FourOhFour</div>;
}
